import { createActions, createReducer } from 'reduxsauce'

import RemuneracaoService from '../../servicos/DetalhesRemuneracaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaRemuneracaoInicio: [],
    buscaRemuneracaoSucesso: ['remuneracao'],
    buscaRemuneracaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    resultado: [],
    selecionado: null,
    dataAtualizacaoDados: null,
}

// Ação para busca completa
Creators.buscaRemuneracao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaRemuneracaoInicio())
        let serv = new RemuneracaoService()
        return serv
            .consultarDetalhes(filtro)
            .then(response => dispatch(Creators.buscaRemuneracaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaRemuneracaoErro(error)))
    }
}

const buscaRemuneracaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaRemuneracaoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaRemuneracaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, resultado: action.remuneracao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_REMUNERACAO_INICIO]: buscaRemuneracaoInicio,
    [Types.BUSCA_REMUNERACAO_ERRO]: buscaRemuneracaoErro,
    [Types.BUSCA_REMUNERACAO_SUCESSO]: buscaRemuneracaoSucesso,
})
